import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';

class Panel extends Component {
    render() {
        const p = this.props;

        return (
            <Card>
                <Card.Body>
                    <Card.Title>
                        {p.title}
                    </Card.Title>
                    {p.children}

                </Card.Body>
            </Card>
        );
    }
}

export default Panel;